// src/Aerosync.ts
var Aerosync = class {
  constructor(options) {
    this.iframeDetails = {};
    this.options = options || {};
    this.options.onLoad = this.options.onLoad || function() {
    };
    this.options.onClose = this.options.onClose || function() {
    };
    this.options.onSuccess = this.options.onSuccess || function() {
    };
    this.options.onEvent = this.options.onEvent || function() {
    };
    this.options.onError = this.options.onError || function() {
    };
    window.addEventListener("message", this._onPostMessage.bind(this));
  }
  launch() {
    let path = "?token=" + this.options.token + (this.options.consumerId ? `&consumerId=${this.options.consumerId}` : "") + (this.options.deeplink ? `&deeplink=${this.options.deeplink}` : "") + (this.options.domain ? `&domain=${this.options.domain}` : "") + (this.options.handleMFA ? `&handleMFA=${this.options.handleMFA}&jobId=${this.options.jobId}&userId=${this.options.userId}` : "");
    let bg = this.options.style && this.options.style.bgColor && this.options.style.opacity ? this.options.style.bgColor + Math.floor(this.options.style.opacity * 255).toString(16) : "#000000b2";
    let url = this.options.environment === "local" ? "http://localhost:8080/" + path : this.options.environment === "staging" ? "https://staging.aerosync.com/" + path : this.options.environment === "dev" ? "https://qa.aerosync.com/" + path : this.options.environment === "production" ? "https://www.aerosync.com/" + path : "";
    let width = this.options.style && this.options.style.width ? this.options.style.width : "375px";
    let height = this.options.style && this.options.style.height ? this.options.style.height : "688px";
    let iframe = document.createElement("iframe");
    let widgetBox = document.createElement("div");
    this.targetDocument = this.options.targetDocument || document;
    iframe.setAttribute("width", width);
    iframe.setAttribute("height", height);
    iframe.setAttribute("border", "0");
    iframe.setAttribute("frame", "0");
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowTransparency", "true");
    iframe.setAttribute("src", url);
    iframe.setAttribute("marginheight", "0");
    iframe.setAttribute("marginwidth", "0");
    iframe.onload = () => {
      this.options.onLoad();
    };
    iframe.setAttribute("title", this.options.iframeTitle);
    widgetBox.setAttribute("id", "widget-box");
    this.targetElement = this.targetDocument.getElementById(this.options.id);
    this.targetElement.innerHTML = "";
    this.targetElement.appendChild(widgetBox);
    let widgetBoxElement = this.targetDocument.getElementById("widget-box");
    widgetBoxElement.style.display = "flex";
    widgetBoxElement.style.position = "fixed";
    widgetBoxElement.style.width = "100%";
    widgetBoxElement.style.left = "0";
    widgetBoxElement.style.top = "0";
    widgetBoxElement.style.backgroundColor = bg;
    widgetBoxElement.style.zIndex = this.options.zIndex || "1";
    widgetBoxElement.style.height = "100%";
    widgetBoxElement.style.justifyContent = "center";
    widgetBoxElement.style.alignItems = "center";
    if (window.matchMedia("(max-height: 700px)").matches) {
      iframe.setAttribute("height", "95%");
    }
    widgetBoxElement.innerHTML = "";
    widgetBoxElement.appendChild(iframe);
    this.iframeDetails = { iframe };
  }
  _onPostMessage(t) {
    let e = {};
    if (this.iframeDetails && this.iframeDetails.iframe && t.source === this.iframeDetails.iframe.contentWindow) {
      try {
        e = JSON.parse(t.data);
      } catch (t2) {
        console.warn("Error processing event", t2);
      }
      if (e.type) {
        this._handleEvent(e);
      }
    }
  }
  _handleEvent(t) {
    switch (t.type) {
      case "pageSuccess":
        this.options.onSuccess(t.payload);
        break;
      case "widgetPageLoaded":
        this.options.onEvent(t.payload, t.type);
        break;
      case "widgetLoaded":
        this.options.onLoad();
        break;
      case "widgetClose":
        this.targetDocument.querySelector('iframe[title="' + this.options.iframeTitle + '"]').remove();
        this.targetDocument.querySelector("#widget-box").remove();
        this.options.onClose();
        break;
      case "widgetError":
        this.options.onError(t.payload);
        break;
    }
  }
};

// src/index.ts
function openWidget(options) {
  return new window.Aerosync(options);
}
window.Aerosync = Aerosync;
export {
  openWidget
};
//# sourceMappingURL=index.mjs.map